import { render, staticRenderFns } from "./CookieConsentAlert.vue?vue&type=template&id=354d9d1c&scoped=true&lang=pug"
import script from "./CookieConsentAlert.vue?vue&type=script&lang=js"
export * from "./CookieConsentAlert.vue?vue&type=script&lang=js"
import style0 from "./CookieConsentAlert.vue?vue&type=style&index=0&id=354d9d1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354d9d1c",
  null
  
)

export default component.exports